import Skeleton, { SkeletonTheme } from 'react-loading-skeleton'
import 'react-loading-skeleton/dist/skeleton.css'

import './index.scss'

export function DashboardCardSkeleton() {
  return (
    <div className="DashboardCardSkeleton">
      <div className="DashboardCardSkeleton-thumbnail" />
      <div className="DashboardCardSkeleton-content">
        <SkeletonTheme baseColor="var(--color_neutral_400)">
          <Skeleton width={109} height={16} borderRadius={20} />
          <Skeleton width="100%" height={24} borderRadius={20} />
          <div>
            <Skeleton width="100%" height={10} borderRadius={20} />
            <Skeleton width={155} height={10} borderRadius={20} />
          </div>
        </SkeletonTheme>
      </div>
    </div>
  )
}
